/* global Rx, Redux, devToolsExtension */

const { createStore } = Redux;

const deepLinkMap = {
	"p4-126_bbc_day_cab": {
		truckModel: "P4",
		cabType: "day",
		truckCab: "126\" BBC Day Cab"
	},
	"p4-126_bbc_72_rr": {
		truckModel: "P4",
		cabType: "sleeper",
		truckCab: "126\" BBC 72\" RR"
	}
}

const initState = {
	"standalone": false,
	"defaultTruck": "p4-126_bbc_day_cab",
	"truckModel": "P4",
	"cabType": "",
	"truckCab": "",
	"interiorViewRadius": 450,
	"hotspotAngle": 315,
	"hotspotScaleWidth": 1365,
	"hotspotScaleHeight": 910,
	"nav": "explore",
	"navs": [
		"explore"
	],
	"view": "exterior",
	"views": [
		"exterior",
		"interior"
	],
	"pillar": "Fuel Efficiency",
	"pillars": [
		{
			id: "fuel-efficiency",
			name: "Fuel Efficiency",
			icon: "icon-fuel-efficiency"
		},
		{
			id: "connectivity",
			name: "Connectivity",
			icon: "icon-connectivity"
		},
		{
			id: "safety",
			name: "Safety",
			icon: "icon-safety"
		},
		{
			id: "quality",
			name: "Quality",
			icon: "icon-quality"
		},
		{
			id: "uptime",
			name: "Uptime",
			icon: "icon-uptime"
		},
		{
			id: "driver-experience",
			name: "Driver Experience",
			icon: "icon-driver-experience"
		}
	],
	"viewOptions": [
		{
			id: "exterior",
			name: "Exterior"
		},
		{
			id: "interior",
			name: "Interior"
		},
		{
			id: "powertrain",
			name: "Powertrain/Chassis"
		},
		{
			id: "safety",
			name: "Safety/Connectivity"
		}
	],
	"viewOption": "Exterior",
	"interiorBuildSettings": {},
	"interiorBuildChange": {},
	"exteriorBuildSettings": {},
	"exteriorBuildChange": {},
	"powertrainOptions": [
		"Powertrain Package",
		"Engine",
		"Transmission",
		"Front Axle",
		"Rear Axle",
		"Rear Axle Ratios",
		"Axle Lubrication Management",
		"Intelligent Powertrain Management",
		"Front Suspension",
		"Rear Suspension",
	],
	// "powertrainCategoryRules": {
	// 	"Transmission": true,
	// 	"Front Axle": true,
	// 	"Rear Axle": true,
	// 	"Front Suspension": true,
	// 	"Rear Suspension": true
	// },
	"powertrainCategoryRules": [
		"Transmission",
		"Front Axle",
		"Rear Axle",
		"Front Suspension",
		"Rear Suspension"
	],
	"powertrainBuildSettings": {},
	"safetyOptions": [
		"Safety",
		"Forward Radar System",
		"Side Object Detection",
		"Camera System",
		"Video Capture",
	],
	"safetyBuildSettings": {},
	"connectivityOptions": [
		"Detroit Connect",
		"Zonar"
	],
	"connectivityBuildSettings": {},
	"activeFab": false,
	"clearActiveFab": false,
	"dataReady": false
};

function configurator(state = initState, action) {
	let tempState;
	switch (action.type) {
		case 'DEEP_LINK_LOAD':
			return Object.assign({}, state, {
				truckModel: deepLinkMap[action.data.truck] ?
					deepLinkMap[action.data.truck].truckModel : state.truckModel,
				cabType: deepLinkMap[action.data.truck] ?
					deepLinkMap[action.data.truck].cabType : state.cabType,
				truckCab: deepLinkMap[action.data.truck] ?
					deepLinkMap[action.data.truck].truckCab : state.truckCab,
				view: action.data.view,
				pillar: action.data.pillar,
				standalone: action.data.standalone
			});
		case 'LOAD_OPTIONS_MATRIX':
			return Object.assign({}, state, {
				optionsMatrix: action.data
			});
		case 'LOAD_ADS_FABS':
			return Object.assign({}, state, {
				adsFabs: _.filter(action.data.assets, (asset) => {
					return asset.type === "FAB"
				}),
				adsVids: _.filter(action.data.assets, (asset) => {
					return asset.type === "VID"
				})
			});
		case 'FORMAT_ADS_PATH_TREE':
			return Object.assign({}, state, {
				pathTree: formatPathTree(action.data, (val, key) => {
					return val.name;
				})
			});
		case 'LOAD_INTERIOR_MAP':
			return Object.assign({}, state, {
				interiorMap: action.data
			});
		case 'LOAD_EXTERIOR_MAP':
			return Object.assign({}, state, {
				exteriorMap: action.data
			});
		case 'ALL_DATA_LOADED':
			return Object.assign({}, state, {
				dataReady: true
			});
		case 'INTERIOR_BUILD_CHANGE':
			return Object.assign({}, state, {
				interiorBuildSettings: Object.assign({}, state.interiorBuildSettings, action.buildSetting),
				interiorBuildChange: Object.assign({}, action.buildSetting)
			});
		case 'EXTERIOR_BUILD_CHANGE':
			return Object.assign({}, state, {
				exteriorBuildSettings: Object.assign({}, state.exteriorBuildSettings, action.buildSetting),
				exteriorBuildChange: Object.assign({}, action.buildSetting)
			});
		case 'POWERTRAIN_BUILD_CHANGE':
			return Object.assign({}, state, {
				powertrainBuildSettings: Object.assign({}, state.powertrainBuildSettings, action.buildSetting)
			});
		case 'SAFETY_BUILD_CHANGE':
			return Object.assign({}, state, {
				safetyBuildSettings: Object.assign({}, state.safetyBuildSettings, action.buildSetting)
			});
		case 'INTERIOR_BUILD_SETTINGS_INIT':
			return Object.assign({}, state, {
				interiorBuildSettings: action.data
			});
		case 'EXTERIOR_BUILD_SETTINGS_INIT':
			return Object.assign({}, state, {
				exteriorBuildSettings: action.data
			});
		case 'MAIN_NAV_CHANGE':
			return Object.assign({}, state, {
				nav: action.data,
				activeFab: false,
				clearActiveFab: false,
				interiorBuildChange: {},
				exteriorBuildChange: {},
				actionType: "main_nav_change"
			});
		case 'VIEW_CHANGE':
			return Object.assign({}, state, {
				view: action.data,
				viewOption: _.capitalize(action.data),
				activeFab: false,
				clearActiveFab: false,
				actionType: "view_change"
			});
		case 'PILLAR_CHANGE':
			return Object.assign({}, state, {
				pillar: action.data,
				activeFab: false,
				clearActiveFab: false,
				exteriorBuildChange: Object.assign({}, {
					"Pillar": action.data
				}),
				interiorBuildChange: Object.assign({}, {
					"Pillar": action.data
				}),
				actionType: "pillar_change"
			});
		case 'VIEW_OPTION_CHANGE':
			return Object.assign({}, state, {
				view: (action.data.toLowerCase() === "interior" || action.data.toLowerCase() === "exterior" ?
				action.data.toLowerCase() : state.view),
				viewOption: action.data,
				activeFab: false,
				clearActiveFab: false,
				exteriorBuildChange: Object.assign({}, {
					"ViewOption": action.data
				}),
				interiorBuildChange: Object.assign({}, {
					"ViewOption": action.data
				})
			});
		case 'ACTIVE_FAB_CHANGE':
			return Object.assign({}, state, {
				activeFab: action.data,
				clearActiveFab: false,
				actionType: "active_fab_change"
			});
		case 'ACTIVE_FAB_CLEAR':
			return Object.assign({}, state, {
				activeFab: false,
				clearActiveFab: true,
				actionType: "active_fab_clear"
			});
		case 'CAB_CHANGE':
			return Object.assign({}, state, {
				cabType: action.data.cabType,
				truckCab: action.data.truckCab,
				interiorBuildSettings: getBuildSettingsInit(state, action.data.truckCab, "Interior"),
				exteriorBuildSettings: getBuildSettingsInit(state, action.data.truckCab, "Exterior"),
				powertrainBuildSettings: getBuildSettingsInit(state, action.data.truckCab, "Components", state.powertrainOptions),
				safetyBuildSettings: getBuildSettingsInit(state, action.data.truckCab, "Components", state.safetyOptions),
				connectivityBuildSettings: getBuildSettingsInit(state, action.data.truckCab, "Components", state.connectivityOptions),
				actionType: "cab_change"
			});
		case 'CAB_RESET':
			return Object.assign({}, state, {
				cabType: "",
				truckCab: "",
				activeFab: false,
				clearActiveFab: false,
				nav: "explore",
				view: "exterior",
				pillar: "Fuel Efficiency",
				actionType: "cab_reset"
			});
		default:
			return state;
	}
}

/**
 * Take the path tree Nodes format and convert it to named properties object format
 * @param obj - path tree data
 * @param cb - formatting callback
 * @returns {*} - formatted object
 */
function formatPathTree(obj, cb) {
	if (_.isUndefined(obj)) {
		throw new Error(`map-keys-deep-lodash expects an object but got ${typeof obj}`);
	}

	if (obj.nodes) {
		obj = _.mapKeys(obj, cb);
	} else if (_.isArray(obj)) {
		obj = _.mapKeys(obj, cb);
	} else {
		return {
			id: obj.id
		}
	}

	let res = {};

	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			const val = obj[key];
			if (_.isArray(val)) {
				res = formatPathTree(val, cb);
			} else if (_.isObject(val)) {
				res[key] = formatPathTree(val, cb);
			} else {
				res.id = obj.id;
			}
		}
	}

	return res;
}

function getBuildSettingsInit(state, truckCab, view, filter) {
	let buildSettings = {},
		options = state.optionsMatrix[view];

	if (filter) {
		options = _.pick(options, filter);
	}

	_.forEach(options, function (component, componentKey) {
		if (componentKey === "Cab") {
			buildSettings.Cab = "cab";
		} else {
			_.forEach(component, function (category) {
				let defaultOption = _.find(category, option => {
						return option[state.truckModel + " " + truckCab] === "*";
					}) || _.find(category, option => {
						return option[state.truckModel + " " + truckCab] === "X";
					});
				buildSettings[componentKey] = defaultOption ? defaultOption.Key : false;
			});
		}
	});
	return buildSettings;
}

export const store = createStore(configurator,
	window.devToolsExtension && window.devToolsExtension());
export const store$ = Rx.Observable.from(store);